import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
import { FadeInAnimation } from '../shared';

const ReviewSection = (props) => {    
    const { reviews } = props;
    return (
        <div className='review-section-container'>
            <div className='container-root container-root-maxWidthMd review-section-container-setting'>
                <div className='main-grid-container main-grid-spacing-xs-3 about-section-grid-container'>
                    {renderReviews(reviews)}
                </div>
            </div>
        </div>
    );
};

const renderReviews = (reviews) => {
    if (!reviews) {
        return null;
    }
    return _.map(reviews, (review, index) => {
        const title = _.get(review, 'title');
        const paragraph = _.get(review, 'paragraph');
        const person = _.get(review, 'person');
        const date = _.get(review, 'date_of_review');
        let formattedDate = moment() - moment(date);
        formattedDate = moment(formattedDate).format('M');
        const stars = _.get(review, 'star_count');
        return (
            <div className='main-grid-item main-grid-md-5' key={index}>
                <FadeInAnimation>
                    <div>
                        {renderStars(stars)}
                        <h4 className='review-section-header4'>&apos;{title}&apos;</h4>
                        <p className='review-section-paragraph'>{paragraph}</p>
                        <h6 className='review-section-header6'>
                            {person} - {formattedDate} months ago
                        </h6>
                    </div>
                </FadeInAnimation>
            </div>
        );
    });
};

const renderStars = (starCount) => {
    const maxStars = 5;
    const starDifference = maxStars - starCount;
    const stars = [];
    for (let i = 0; i < starCount; i += 1) {
        stars.push(<img className='review-section-image' key={i} src="/assets/images/full_star.png" alt="yellow-start" />);
    }
    if (starDifference > 0) {
        for (let i = 0; i < starDifference; i += 1) {
            stars.push(
                <img
                    className='review-section-image'
                    key={maxStars - starDifference + i}
                    src="/assets/images/empty_star.png"
                    alt="grey-start"
                />,
            );
        }
    }
    return stars;
};

export default ReviewSection;

ReviewSection.propTypes = {
    reviews: PropTypes.array,
};
